import React from "react"
import { Redirect } from "react-router-dom"

// // Pages Component
import Chat from "../pages/Chat/Chat"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

// Pages Calendar
import Calendar from "../pages/Calendar/index"

// //Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index"
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail"
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index"
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index"
import EcommerceCart from "../pages/Ecommerce/EcommerceCart"
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout"
import EcommerceShops from "../pages/Ecommerce/EcommerceShops/index"
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceAddProduct"

//Email
import EmailInbox from "../pages/Email/email-inbox"
import EmailRead from "../pages/Email/email-read"
import EmailBasicTemplte from "../pages/Email/email-basic-templte"
import EmailAlertTemplte from "../pages/Email/email-template-alert"
import EmailTemplateBilling from "../pages/Email/email-template-billing"

//Invoices
import InvoicesList from "../pages/Invoices/invoices-list"
import InvoiceDetail from "../pages/Invoices/invoices-detail"

//Contacts
import ContactsGrid from "../pages/Contacts/contacts-grid"
import ContactsList from "../pages/Contacts/ContactList/contacts-list"
import ContactsProfile from "../pages/Contacts/ContactsProfile/contacts-profile"

//Pages
import PagesStarter from "../pages/Utility/pages-starter"
import PagesMaintenance from "../pages/Utility/pages-maintenance"
import PagesComingsoon from "../pages/Utility/pages-comingsoon"
import PagesTimeline from "../pages/Utility/pages-timeline"
import PagesFaqs from "../pages/Utility/pages-faqs"
import PagesPricing from "../pages/Utility/pages-pricing"
import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"

//Ui
import UiAlert from "../pages/Ui/UiAlert"
import UiButtons from "../pages/Ui/UiButtons"
import UiCards from "../pages/Ui/UiCards"
import UiCarousel from "../pages/Ui/UiCarousel"
import UiColors from "../pages/Ui/UiColors"
import UiDropdown from "../pages/Ui/UiDropdown"
import UiGeneral from "../pages/Ui/UiGeneral"
import UiGrid from "../pages/Ui/UiGrid"
import UiImages from "../pages/Ui/UiImages"
import UiLightbox from "../pages/Ui/UiLightbox"
import UiModal from "../pages/Ui/UiModal"
import UiOffcanvas from "../pages/Ui/UiOffcanvas"
import UiProgressbar from "../pages/Ui/UiProgressbar"
import UiPlaceholders from "../pages/Ui/UiPlaceholders"
import UiSweetAlert from "../pages/Ui/UiSweetAlert"
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions"
import UiTypography from "../pages/Ui/UiTypography"
import UiToasts from "../pages/Ui/UiToasts"
import UiVideo from "../pages/Ui/UiVideo"
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout"
import UiRating from "../pages/Ui/UiRating"
import UiRangeSlider from "../pages/Ui/UiRangeSlider"
import UiNotifications from "../pages/Ui/ui-notifications"
import UiImageCropper from "../pages/Ui/ui-image-cropper"

// Forms
import BasicElements from "../pages/Forms/BasicElements"
import FormLayouts from "../pages/Forms/FormLayouts"
import FormAdvanced from "../pages/Forms/FormAdvanced"
import FormEditors from "../pages/Forms/FormEditors"
import FormValidations from "../pages/Forms/FormValidations"
import FormMask from "../pages/Forms/FormMask"
import FormRepeater from "../pages/Forms/FormRepeater"
import FormUpload from "../pages/Forms/FormUpload"
import FormWizard from "../pages/Forms/FormWizard"
import FormXeditable from "../pages/Forms/FormXeditable"

//Tables
import BasicTables from "../pages/Tables/BasicTables"
import DatatableTables from "../pages/Tables/DatatableTables"
import ResponsiveTables from "../pages/Tables/ResponsiveTables"
import EditableTables from "../pages/Tables/EditableTables"

// Charts
import ChartApex from "../pages/Charts/Apexcharts"
import ChartjsChart from "../pages/Charts/ChartjsChart"
import EChart from "../pages/Charts/EChart"
import SparklineChart from "../pages/Charts/SparklineChart"
import ChartsKnob from "../pages/Charts/charts-knob"

//Icons

import IconUnicons from "../pages/Icons/IconUnicons"
import IconBoxicons from "../pages/Icons/IconBoxicons"
import IconDripicons from "../pages/Icons/IconDripicons"
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign"
import IconFontawesome from "../pages/Icons/IconFontawesome"

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle"
import MapsVector from "../pages/Maps/MapsVector"
import MapsLeaflet from "../pages/Maps/MapsLeaflet"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Register1 from "../pages/AuthenticationInner/Register"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

// Profile
import UserProfile from "../pages/Authentication/user-profile"
import Admins from "../pages/Admins/ContactList/admins-list"
import Ceremonies from "../pages/ceremony/CeremonyList/ceremonies-list"
import Vendor_cats from "../pages/vendor_cat/Vendor_CatList/vendor_cat-list"
import Vendors from "../pages/vendor/VendorList/vendors-list"
import Ceremony_pack from "../pages/ceremony_pack/CeremonyList/ceremonies_pack-list"
import EditSettings from "../pages/settings/editSettings"
import AboutUs from "../pages/settings/AboutUs"
import AppFeatures from "../pages/settings/AppFeatures"
import PrivacyPolicy from "../pages/settings/PrivacyPolicy"
import TermsAndConditions from "../pages/settings/TermsAndConditions"
import PhonesList from "../pages/settings/contact/phones/phones-list"
import EmailsList from "../pages/settings/contact/emails/emails-list"
import AddressList from "../pages/settings/contact/address/address-list"
import HowItWorks from "../pages/settings/contact/how_it_works"
import AddMediaVendor from "../pages/vendor/Vendor-mediaList/AddMediaVendor"
import AddVendor from "../pages/vendor/VendorList/AddVendor"
import VendorMediaList from "../pages/vendor/Vendor-mediaList/vendors_media-list"
import Clients from "../pages/clients/ClientsList/clients-list"
import AddClient from "../pages/clients/ClientsList/AddClient"
import Events from "../pages/clients/Events/events-list"
import EventsList from "../pages/Events_list/events-list"
import EventsListVendor from "../pages/vendor/Events_list/events-list"
import VendorPricingList from "../pages/vendor/Vendor-pricingList/vendors_pricing-list"
import AddPricingVendor from "../pages/vendor/Vendor-pricingList/AddPricingVendor"
import Budget_percentage from "../pages/Budget_percentage/CeremonyList/budget_percentage-list"
import ClientsPurchases from "../pages/clients/purchases/PurchasesList/purhases-list"
import VendorImportCSV from "../pages/vendor/CSV_Import"
import typeServicesList from "../pages/vendor/Type_services/List/list"
import TypeSettingsList from "../pages/vendor/Type_settings/List/list"
import Howitworks from "../pages/settings/how_it_work/CeremonyList/howitwork_list"
import RecoveredPassword from "../pages/Authentication/RecoveredPassword"
import VendorFileManager from "../pages/vendor/file-manager/vendors_file-manager"
import VendorFileManagerFiles from "../pages/vendor/file-manager/vendors_file-manager-files"
import PartnerRegistration from "../pages/clients/partner_registration"
import Faqs from "../pages/settings/faq/CeremonyList/faq_list"
import Reviews from "../pages/reviews/reviewsList/reviews-list"
import SettingsData from "../pages/policy/settings/settingsT"
import SettingsDataP from "../pages/policy/settings/settingsP.js"
import SettingsDataT from "../pages/policy/settings/settingsT"
import BroadcastPage from "../pages/Broadcast"

let userData = JSON.parse(localStorage.getItem("authUser"))

const userRoutes =
  userData?.id == 3
    ? [
        {
          path: "/",
          exact: true,
          component: () => <Redirect to="/broadcast" />,
        },
        { path: "/broadcast", component: BroadcastPage },
      ]
    : [
        { path: "/dashboard", component: Dashboard },
        { path: "/Admins", component: Admins },
        { path: "/ceremony-type", component: Ceremonies },
        { path: "/vendor-categories", component: Vendor_cats },
        { path: "/vendors", component: Vendors },
        { path: "/pending_vendors", component: Vendors },
        { path: "/how-it-works", component: Howitworks },
        { path: "/faq", component: Faqs },
        { path: "/vendors/csv-i", component: VendorImportCSV },
        { path: "/vendor/media/:vendor_id", component: VendorMediaList },
        { path: "/vendor/events/:vendor_id", component: EventsListVendor },
        { path: "/vendor/pricing/:vendor_id", component: VendorPricingList },
        { path: "/vendor-pricing/add", component: AddPricingVendor },
        { path: "/vendor-pricing/edit", component: AddPricingVendor },
        {
          path: "/vendor/file-manager/folders/:id",
          component: VendorFileManager,
        },
        {
          path: "/vendor/file-manager/folders/files/:id",
          component: VendorFileManagerFiles,
        },

        { path: "/vendor-type-services/:id", component: typeServicesList },
        { path: "/vendor-type-settings/:id", component: TypeSettingsList },
        { path: "/vendors/add", component: AddVendor },
        { path: "/vendors/edit/:id", component: AddVendor },
        { path: "/calendar", component: Calendar },
        { path: "/ceremony-pack", component: Ceremony_pack },
        { path: "/budget-percentage", component: Budget_percentage },
        { path: "/vendors/add-media/:vendor_id", component: AddMediaVendor },
        { path: "/vendors/edit-media", component: AddMediaVendor },
        { path: "/clients", component: Clients },
        { path: "/clients/add", component: AddClient },
        { path: "/purchases", component: ClientsPurchases },
        { path: "/reviews", component: Reviews },
        { path: "/clients/edit", component: AddClient },
        { path: "/clients/events/:client_id", component: Events },

        { path: "/events", component: EventsList },
        { path: "/events/:vendor_id", component: EventsList },

        { path: "/broadcast", component: BroadcastPage },
        { path: "/settings", component: EditSettings },
        { path: "/about-us", component: AboutUs },
        { path: "/privacy-policy", component: PrivacyPolicy },
        { path: "/terms-and-conditionss", component: TermsAndConditions },
        { path: "/app-features", component: AppFeatures },
        { path: "/phones-contact", component: PhonesList },
        { path: "/emails-contact", component: EmailsList },
        { path: "/address", component: AddressList },
        // { path: "/how-it-works", component: HowItWorks },
        //chat
        { path: "/chat", component: Chat },

        //Ecommerce
        { path: "/ecommerce-products", component: EcommerceProducts },
        {
          path: "/ecommerce-product-detail",
          component: EcommerceProductDetail,
        },
        { path: "/ecommerce-products/:id", component: EcommerceProductDetail },
        { path: "/ecommerce-orders", component: EcommerceOrders },
        { path: "/ecommerce-customers", component: EcommerceCustomers },
        { path: "/ecommerce-cart", component: EcommerceCart },
        { path: "/ecommerce-checkout", component: EcommerceCheckout },
        { path: "/ecommerce-shops", component: EcommerceShops },
        { path: "/ecommerce-add-product", component: EcommerceAddProduct },

        //Email
        { path: "/email-inbox", component: EmailInbox },
        { path: "/email-read", component: EmailRead },
        { path: "/email-template-basic", component: EmailBasicTemplte },
        { path: "/email-template-alert", component: EmailAlertTemplte },
        { path: "/email-template-billing", component: EmailTemplateBilling },

        //Invoices
        { path: "/invoices-list", component: InvoicesList },
        { path: "/invoices-detail", component: InvoiceDetail },
        { path: "/invoices-detail/:id", component: InvoiceDetail },

        // Contacts
        { path: "/contacts-grid", component: ContactsGrid },
        { path: "/contacts-list", component: ContactsList },
        { path: "/contacts-profile", component: ContactsProfile },

        //Utility
        { path: "/pages-starter", component: PagesStarter },
        { path: "/pages-timeline", component: PagesTimeline },
        { path: "/pages-faqs", component: PagesFaqs },
        { path: "/pages-pricing", component: PagesPricing },

        // Ui
        { path: "/ui-alerts", component: UiAlert },
        { path: "/ui-buttons", component: UiButtons },
        { path: "/ui-cards", component: UiCards },
        { path: "/ui-carousel", component: UiCarousel },
        { path: "/ui-colors", component: UiColors },
        { path: "/ui-dropdowns", component: UiDropdown },
        { path: "/ui-general", component: UiGeneral },
        { path: "/ui-grid", component: UiGrid },
        { path: "/ui-images", component: UiImages },
        { path: "/ui-lightbox", component: UiLightbox },
        { path: "/ui-modals", component: UiModal },
        { path: "/ui-offcanvas", component: UiOffcanvas },
        { path: "/ui-progressbars", component: UiProgressbar },
        { path: "/ui-placeholders", component: UiPlaceholders },
        { path: "/ui-sweet-alert", component: UiSweetAlert },
        { path: "/ui-tabs-accordions", component: UiTabsAccordions },
        { path: "/ui-typography", component: UiTypography },
        { path: "/ui-toasts", component: UiToasts },
        { path: "/ui-video", component: UiVideo },
        { path: "/ui-session-timeout", component: UiSessionTimeout },
        { path: "/ui-rating", component: UiRating },
        { path: "/ui-rangeslider", component: UiRangeSlider },
        { path: "/ui-notifications", component: UiNotifications },
        { path: "/ui-image-cropper", component: UiImageCropper },

        // Forms
        { path: "/basic-elements", component: BasicElements },
        { path: "/form-layouts", component: FormLayouts },
        { path: "/form-advanced", component: FormAdvanced },
        { path: "/form-editors", component: FormEditors },
        { path: "/form-mask", component: FormMask },
        { path: "/form-repeater", component: FormRepeater },
        { path: "/form-uploads", component: FormUpload },
        { path: "/form-wizard", component: FormWizard },
        { path: "/form-validation", component: FormValidations },
        { path: "/form-xeditable", component: FormXeditable },

        // Tables
        { path: "/tables-basic", component: BasicTables },
        { path: "/tables-datatable", component: DatatableTables },
        { path: "/tables-responsive", component: ResponsiveTables },
        { path: "/tables-editable", component: EditableTables },

        //Charts
        { path: "/apex-charts", component: ChartApex },
        { path: "/chartjs-charts", component: ChartjsChart },
        { path: "/e-charts", component: EChart },
        { path: "/sparkline-charts", component: SparklineChart },
        { path: "/charts-knob", component: ChartsKnob },

        // Icons
        { path: "/icons-unicons", component: IconUnicons },
        { path: "/icons-boxicons", component: IconBoxicons },
        { path: "/icons-dripicons", component: IconDripicons },
        { path: "/icons-materialdesign", component: IconMaterialdesign },
        { path: "/icons-fontawesome", component: IconFontawesome },

        // Maps
        { path: "/maps-google", component: MapsGoogle },
        { path: "/maps-vector", component: MapsVector },
        { path: "/maps-leaflet", component: MapsLeaflet },

        // //profile
        { path: "/profile", component: UserProfile },

        // this route should be at the end of all other routes
        {
          path: "/",
          exact: true,
          component: () => <Redirect to="/dashboard" />,
        },
      ]

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/recovered-password/:token", component: RecoveredPassword },
  { path: "/partner-registration/:token", component: PartnerRegistration },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/privacy", component: SettingsDataP },
  { path: "/terms-and-conditions", component: SettingsDataT },

  { path: "/pages-maintenance", component: PagesMaintenance },
  { path: "/pages-comingsoon", component: PagesComingsoon },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },

  // Authentication Inner
  { path: "/pages-login", component: Login1 },
  { path: "/pages-register", component: Register1 },
  { path: "/page-recoverpw", component: Recoverpw },
  { path: "/auth-lock-screen", component: LockScreen },
]

export { userRoutes, authRoutes }
